import * as Sentry from "@sentry/react";
import * as SentryBrowser from "@sentry/browser";


Sentry.init({
	sendDefaultPii: false,
	dsn: process.env.REACT_APP_SENTRY_DSN,
	environment: process.env.REACT_APP_ENVIRONMENT,
	enabled: process.env.REACT_APP_ENVIRONMENT !== 'development',
	integrations: [
		Sentry.captureConsoleIntegration({
			levels: ['error']
		}),
		SentryBrowser.browserApiErrorsIntegration({
			XMLHttpRequest: true,
		}),
		SentryBrowser.httpClientIntegration(),
		Sentry.httpContextIntegration(),
		Sentry.browserTracingIntegration(),
	],

});
